<template>
  <div class="form-input-wrapper">
    <label class="form-label" :for="id">
      <span>{{ label }}</span
      ><span v-if="required">*</span>
    </label>
    <textarea
      :id="id"
      class="form-textarea"
      type="text"
      :name="name"
      v-model="value"
      :required="required"
    />
  </div>
</template>

<script>
export default {
  props: ["name", "label", "id", "required", "base"],
  data() {
    return {
      value: "",
    };
  },
   methods: {
    // setValue() {
    //   if (typeof(this.base) == "string") {
    //     this.value = this.base;
    //   }
    // },

  },

  mounted() {
    //   let vm = this;
    // vm.$nextTick(function () {
    //   this.inputType = vm.id;
    //   setTimeout(this.setValue, 1000);
    // });
  },
};
</script>
